<template>
  <Modal ref="modal" :is-modal-open="showSettingsModal" @close="closeModal">
    <div class="md:flex h-full w-full">
      <AsideMobile v-if="isMobile" @toggle="toggle" />
      <Aside v-if="!isMobile" class="flex-shrink-0" :active-state="activeState" />

      <General v-if="!showAside && activeState === 'Account'" key="General" @back="toggle" />
      <TeamMembers v-if="!showAside && activeState === 'TeamMembers'" key="TeamMembers" @back="toggle" />
      <Design v-if="!showAside && activeState === 'Design'" key="Design" @back="toggle" />
      <Preferences v-if="!showAside && activeState === 'Preferences'" key="Preferences" @back="toggle" />
      <Keyboard v-if="!showAside && activeState === 'Keyboard'" key="Keyboard" @back="toggle" />
      <Billing v-if="!showAside && activeState === 'Billing'" key="Billing" @back="toggle" />
      <Plans v-if="!showAside && activeState === 'Plans'" key="Plans" title="Your Plan" @back="toggle" />
      <Trash v-if="!showAside && activeState === 'Trash'" key="Trash" @back="toggle" />
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/shared/Modal'
import Aside from '@/components/settings/Aside'
import AsideMobile from '@/components/settings/AsideMobile'
import General from '@/components/settings/General'
import TeamMembers from '@/components/settings/TeamMembers'
import Design from '@/components/settings/Design'
import Keyboard from '@/components/settings/Keyboard'
import Trash from '@/components/settings/Trash'
import Billing from '@/components/settings/Billing'
import Plans from '@/components/settings/Plans'
import Preferences from '@/components/settings/Preferences'

import { mapState, mapMutations, mapGetters } from 'vuex'

export default {
  components: {
    Modal,
    Aside,
    AsideMobile,
    General,
    TeamMembers,
    Design,
    Keyboard,
    Trash,
    Billing,
    Plans,
    Preferences
  },

  computed: {
    ...mapState({
      activeState: state => state.settings.activeState,
      showSettingsModal: state => state.settings.showSettingsModal,
      showAside: state => state.settings.showAside
    }),

    ...mapGetters(['isMobile'])
  },

  watch: {
    isMobile: {
      handler (value) {
        this.toggleAside(value)
      },
      immediate: true
    }
  },

  methods: {
    ...mapMutations(['toggleSettingsModal', 'toggleAside', 'updateBackButton']),

    closeModal () {
      this.toggleSettingsModal(false)
      this.updateBackButton(true)
      this.$nextTick(() => {
        this.toggleAside(this.isMobile)
      })
    },

    toggle () {
      this.toggleAside(!this.showAside)
    }
  }
}
</script>
